module.exports = __webpack_public_path__ + "img/Recuperación de Llaves.5bd3aa35.svg";